"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-unused-vars */
/* eslint-disable indent */
const vue_property_decorator_1 = require("vue-property-decorator");
const TabularAnalyticsController_1 = __importDefault(require("../modules/controllers/TabularAnalyticsController"));
const MixpanelHandler_1 = __importDefault(require("@becrop/components/Modules/Common/Models/MixpanelHandler"));
const ExportCSVSplit_vue_1 = __importDefault(require("./ExportCSVSplit.vue"));
const CustomizePanel_vue_1 = __importDefault(require("./CustomizePanel.vue"));
const FilterPanel_vue_1 = __importDefault(require("./FilterPanel.vue"));
const SearchAction_vue_1 = __importDefault(require("./SearchAction.vue"));
const CheckSet_vue_1 = __importDefault(require("./CheckSet.vue"));
let TabularActions = class TabularActions extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.mixpanelHandler = new MixpanelHandler_1.default();
        this.TABULAR_ANALYTICS_CONTROLLER = TabularAnalyticsController_1.default.getInstance();
    }
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    get loading() {
        return this.TABULAR_ANALYTICS_CONTROLLER.loadingAllPagesFarms;
    }
    exportCSVAll(event) {
        if (this.TABULAR_ANALYTICS_CONTROLLER.tabularMode === 'farms') {
            this.TABULAR_ANALYTICS_CONTROLLER.exportAllFarmsCSV();
        }
        else {
            this.TABULAR_ANALYTICS_CONTROLLER.exportAllFieldsCSVByFarmId(this.TABULAR_ANALYTICS_CONTROLLER.selectedFarm.id);
        }
        this.mixpanelHandler.trackEvent('exportCSVTabular', {
            mode: 'all',
            level: this.TABULAR_ANALYTICS_CONTROLLER.tabularMode,
        });
    }
    exportCSV(event) {
        if (this.TABULAR_ANALYTICS_CONTROLLER.tabularMode === 'farms') {
            this.TABULAR_ANALYTICS_CONTROLLER.exportCSVManually();
        }
        else {
            this.TABULAR_ANALYTICS_CONTROLLER.exportFarmCSVById(this.TABULAR_ANALYTICS_CONTROLLER.selectedFarm.id);
        }
        this.mixpanelHandler.trackEvent('exportCSVTabular', {
            mode: 'current',
            level: this.TABULAR_ANALYTICS_CONTROLLER.tabularMode,
        });
    }
    searchCriteria(newSearchCriteria) {
        this.TABULAR_ANALYTICS_CONTROLLER.updatedSearchCriteria(newSearchCriteria);
    }
    get tree() {
        return this.TABULAR_ANALYTICS_CONTROLLER.filterableColumns;
    }
    changeMode(m) {
        let mode = 'score';
        if (m)
            mode = 'rank_distribution';
        this.TABULAR_ANALYTICS_CONTROLLER.configuration.setMode(mode);
        this.mixpanelHandler.trackEvent('modeTabular', {
            mode: mode,
            level: this.TABULAR_ANALYTICS_CONTROLLER.tabularMode,
        });
    }
    changeUnits(u) {
        let units = 'acre';
        if (u)
            units = 'hectarea';
        this.TABULAR_ANALYTICS_CONTROLLER.configuration.setUnit(units);
        const changeUnits = units === 'acre' ? 'ac' : 'ha';
        this.TABULAR_ANALYTICS_CONTROLLER.switchExtensionUnits(changeUnits);
        this.mixpanelHandler.trackEvent('unitsInTabular', {
            units: units,
            level: this.TABULAR_ANALYTICS_CONTROLLER.tabularMode,
        });
    }
    toggle(a, b) {
        const keys = ['recommendations', 'needs', 'metrics', 'phch_metrics'];
        this.TABULAR_ANALYTICS_CONTROLLER.configuration.columnManager.setChildrenChecked(a, b);
        this.TABULAR_ANALYTICS_CONTROLLER.configuration.columnManager.updateNode(this.TABULAR_ANALYTICS_CONTROLLER.configuration.columnManager.tree, a, b);
        if (b && keys.includes(a.key)) {
            this.TABULAR_ANALYTICS_CONTROLLER.configuration.setPreset(a.key);
        }
        else {
            this.TABULAR_ANALYTICS_CONTROLLER.configuration.unsetPreset(a.key);
        }
        const controller = this.TABULAR_ANALYTICS_CONTROLLER;
        const config = controller.configuration;
        const tree = config.columnManager.tree;
        if (a.key.startsWith('phch_')) {
            if (b) {
                config.unsetPreset('recommendations');
                const nodeR = tree.find((nod) => nod.key === 'recommendations');
                this.TABULAR_ANALYTICS_CONTROLLER.configuration.columnManager.updateNode(this.TABULAR_ANALYTICS_CONTROLLER.configuration.columnManager.tree, nodeR.key, false);
                config.unsetPreset('metrics');
                const nodeM = tree.find((nod) => nod.key === 'metrics');
                this.TABULAR_ANALYTICS_CONTROLLER.configuration.columnManager.updateNode(this.TABULAR_ANALYTICS_CONTROLLER.configuration.columnManager.tree, nodeM.key, false);
                config.unsetPreset('needs');
                const nodeN = tree.find((nod) => nod.key === 'needs');
                this.TABULAR_ANALYTICS_CONTROLLER.configuration.columnManager.updateNode(this.TABULAR_ANALYTICS_CONTROLLER.configuration.columnManager.tree, nodeN.key, false);
                config.setPreset('phch_metrics');
            }
            else {
                const node = tree.find((nod) => nod.key === 'phch_metrics');
                const hasChildsCheked = node.children.some((ch) => ch.checked);
                if (node && !hasChildsCheked) {
                    node.checked = false;
                    config.unsetPreset('phch_metrics');
                }
            }
        }
        if (a.key.startsWith('need_')) {
            if (b) {
                config.unsetPreset('recommendations');
                const nodeR = tree.find((nod) => nod.key === 'recommendations');
                this.TABULAR_ANALYTICS_CONTROLLER.configuration.columnManager.updateNode(this.TABULAR_ANALYTICS_CONTROLLER.configuration.columnManager.tree, nodeR.key, false);
                config.unsetPreset('metrics');
                const nodeM = tree.find((nod) => nod.key === 'metrics');
                this.TABULAR_ANALYTICS_CONTROLLER.configuration.columnManager.updateNode(this.TABULAR_ANALYTICS_CONTROLLER.configuration.columnManager.tree, nodeM.key, false);
                config.setPreset('needs');
            }
            else {
                const node = tree.find((nod) => nod.key === 'needs');
                const hasChildsCheked = node.children.some((ch) => ch.checked);
                if (node && !hasChildsCheked) {
                    node.checked = false;
                    config.unsetPreset('needs');
                }
            }
        }
        if (a.key.startsWith('rec_')) {
            if (b) {
                config.unsetPreset('needs');
                const nodeN = tree.find((nod) => nod.key === 'needs');
                this.TABULAR_ANALYTICS_CONTROLLER.configuration.columnManager.updateNode(this.TABULAR_ANALYTICS_CONTROLLER.configuration.columnManager.tree, nodeN.key, false);
                config.unsetPreset('metrics');
                const nodeM = tree.find((nod) => nod.key === 'metrics');
                this.TABULAR_ANALYTICS_CONTROLLER.configuration.columnManager.updateNode(this.TABULAR_ANALYTICS_CONTROLLER.configuration.columnManager.tree, nodeM.key, false);
                config.setPreset('recommendations');
            }
            else {
                const node = tree.find((nod) => nod.key === 'recommendations');
                const hasChildsCheked = node.children.some((ch) => ch.checked);
                if (node && !hasChildsCheked) {
                    node.checked = false;
                    config.unsetPreset('recommendations');
                }
            }
        }
        if (a.key.startsWith('metric_') || a.key.startsWith('categorie_')) {
            if (b) {
                config.unsetPreset('needs');
                const nodeN = tree.find((nod) => nod.key === 'needs');
                this.TABULAR_ANALYTICS_CONTROLLER.configuration.columnManager.updateNode(this.TABULAR_ANALYTICS_CONTROLLER.configuration.columnManager.tree, nodeN.key, false);
                config.unsetPreset('recommendations');
                const nodeR = tree.find((nod) => nod.key === 'recommendations');
                this.TABULAR_ANALYTICS_CONTROLLER.configuration.columnManager.updateNode(this.TABULAR_ANALYTICS_CONTROLLER.configuration.columnManager.tree, nodeR.key, false);
                config.setPreset('metrics');
            }
            else {
                const node = tree.find((nod) => nod.key === 'metrics');
                const hasChildsCheked = node.children.some((ch) => ch.checked);
                if (node && !hasChildsCheked) {
                    node.checked = false;
                    config.unsetPreset('metrics');
                }
                ;
            }
        }
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], TabularActions.prototype, "theme", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: 'm' })
], TabularActions.prototype, "size", void 0);
TabularActions = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            ExportCSVSplit: ExportCSVSplit_vue_1.default, CustomizePanel: CustomizePanel_vue_1.default, FilterPanel: FilterPanel_vue_1.default, SearchAction: SearchAction_vue_1.default, CheckSet: CheckSet_vue_1.default
        },
    })
], TabularActions);
exports.default = TabularActions;
